import { render, staticRenderFns } from "./CostomerServiceInfo.vue?vue&type=template&id=f8630a12&scoped=true"
import script from "./CostomerServiceInfo.vue?vue&type=script&lang=js"
export * from "./CostomerServiceInfo.vue?vue&type=script&lang=js"
import style0 from "./CostomerServiceInfo.vue?vue&type=style&index=0&id=f8630a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8630a12",
  null
  
)

export default component.exports